import * as React from "react";

const circleColor = "var(--color-check-green)";
const checkColor = "var(--color-bg)";
const checkThickness = "5";

const styles = {
  checkMark: {
    width: "16px",
    height: "16px",

    display: "inline-block",
    marginLeft: "auto",
    marginRight: "auto",
    stroke: checkColor,
    strokeWidth: checkThickness,
    fill: circleColor,
  },
  checkmarkCircle: {
    fill: circleColor,
  },
  checkmarkCheck: {},
};

const Checkmark: React.FunctionComponent<any> = ({ ...props }) => (
  <svg
    style={styles.checkMark}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
    {...props}
  >
    <circle style={styles.checkmarkCircle} cx="26" cy="26" r="25" />
    <path style={styles.checkmarkCheck} d="M14.1 27.2l7.1 7.2 16.7-16.8" />
  </svg>
);

export default Checkmark;
